<template>
 
    <v-dialog
      v-model="display"
      scrollable
      dense
    >
      <template v-slot:activator="{ on, attrs }">
         <v-btn
        v-if="fileName != '_'"
          color="grey darken-4"
          dark
          small
          v-bind="attrs"
          v-on="on"
        >
          KWICs
        </v-btn>
      </template>
      <v-card>
        <v-card-title><b>KWIC-Beispiele für "{{sprichwortname}}"</b></v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">

   <v-simple-table class="kwictab">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Sigle
          </th>
          <th class="text-left">
            
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in $store.state.kwicData"
          :key="item.id"
        >
          <td >{{ item.sigle }}</td>
          <td v-html="item.line"></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

<!--
         <v-data-table
    :headers="dataheaders"
    :items="$store.state.kwicData"
    :items-per-page="5"
    class="elevation-1"
  ></v-data-table> -->
        
        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="display = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

  export default {
    name: 'KwicDialogLeftAlign',
    props: ["fileName", "sprichwortname"],
    data: () => ({
        display: false,
        //kwicURLPath: "http://uwv.ids-mannheim.de/spruchlist/kwicfiles/",
        kwicURLPath: "kwics/",
        dataheaders: [
            {text: 'Sigle', value: 'sigle'},
            {text: '', value: 'first'},
            {text: '', value: 'second'},
            ],
    }),
    methods:{
        closeDisplay() {
            this.display = false;
        },
        getKwicData() {
            console.log(this.kwicURLPath + this.fileName);
            var store = this.$store;

             fetch(this.kwicURLPath + this.fileName + ".json")
            .then(response => response.json()) 
            .then((data) =>
                {console.log("fetch data: " + data.length);
                store.commit('setKwicData', data);
                console.log("fetch data: " + store.state.kwicData[0].id + "  " + store.state.kwicData[0].second);
                })
            .catch(function(err) {
            console.log("error: " + err);
            });
          }

        },
    watch: {
    display(displayDialog) {
      if (displayDialog) {
        // Here you would put something to happen when dialog opens up
        console.log("Dialog was opened!")
        this.getKwicData(this.fileName);
      } else {
        console.log("Dialog was closed!")
      }
    }
}
        // updated() {
        //     this.getKwicData(this.fileName);
        // }
    }
  
  </script>

  <style scoped>
.kwictab {
  font-family: 'Courier New', Courier, monospace
}
</style>